/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const shield = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2 3.474V7.99c0 3.26 2.25 5.684 5.337 6.827.663.245.663.245 1.326 0C11.75 13.673 14 11.249 14 7.989V3.474a.896.896 0 0 0-.534-.807C10.46 2.334 8 1 8 1S5.538 2.334 2.534 2.667A.896.896 0 0 0 2 3.474Z"
    />
  </svg>
)
export default shield
